import React, { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import NewFormWizard from '../../../../components/formWizard/NewFormWizard'
import Layout from '../../../../components/layouts/Layout'
import { eventBoomerangTemplateFrame } from '../slice/createEventSlice'
import NewFormWizardChild from '../../../../components/formWizard/NewFormWziardChild'
import { IoTrashSharp } from 'react-icons/io5'
import http, { URL_S3 } from '../../../../config/BaseUrl'
import { ImEqualizer2 } from 'react-icons/im'
import { LoadingSpinner } from '../../../../components/Loader/Loader'
import EventBoomerangFrameModal from '../../components/Modal/EventBoomerangFrame'

const EventBoomerangFrame = () => {

    const history = useHistory()
    const dispatch = useDispatch()
    // const eventId = history.location.state
    const { event_option, boomerang_template_frame, eventId } = useSelector(state => state.createEvent)
    const [selectedFrame, setSelectedFrame] = useState([])
    const [loading, setLoading] = useState(false)
    const [draftLoading, setDraftLoading] = useState(false)

    const handelTemplate = (e) => {
        e.preventDefault();
        dispatch(eventBoomerangTemplateFrame({ photo_frame: selectedFrame }))
        setLoading(true)
        http.post("event-boomerang-frame", { photo_frame: selectedFrame, eventId }).then(res => {
            setLoading(true)
            if (res.data.photo_frame === 'success') {
                if (event_option.incentive_offer === true) { history.push('/event/incentive-offer', eventId) }
                else if (event_option.filters === true) { history.push('/event/filter', eventId) }
                else if (event_option.form_builder === true) { history.push('/event/form-builder', eventId) }
                else { history.push('/event/summary', eventId) }
            }
        }).catch()
    }

    useEffect(() => {
        if (boomerang_template_frame) {
            if (boomerang_template_frame.length > 0) {
                setSelectedFrame(boomerang_template_frame)
            }
        }
    }, [boomerang_template_frame])

    const setEventFrameByProps = (data) => {
        setSelectedFrame(data)
    }

    const removeProps = (id) => {
        let copyProps = [...selectedFrame]
        copyProps.splice(id, 1)
        setSelectedFrame(copyProps)

    }

    const saveAsDraft = () => {
        dispatch(eventBoomerangTemplateFrame({ photo_frame: selectedFrame }))
        setDraftLoading(true)
        http.post("event-boomerang-frame", { photo_frame: selectedFrame, eventId }).then(res => {
            setDraftLoading(false)
        }).catch(err => setDraftLoading(false))
    }

    const BackToPreviousPage = (e) => {
        e.preventDefault()
        if (event_option.video_frame_option === true) { history.push('/event/video-frame') }
        else if (event_option.frame_option === true) { history.push('/event/frame') }
        else if (event_option.microsite      === true) { history.push('/event/microsite') }
        else if (event_option.water_mark     === true) { history.push('/event/custom-branding') }
        else if (event_option.digital_props  === true) { history.push('/event/digital-prop') }
        else if (event_option.text_messaging === true) { history.push('/event/sms') }
        else if (event_option.email          === true) { history.push('/event/email') }
        else if (event_option.brust_gif      === true) { history.push('/event/brust-gif') }
        else if (event_option.gif            === true) { history.push('/event/gif') }
        else if (event_option.social_media   === true) { history.push('/event/social') }
        else { history.push('/event/options') }
    }

    return (
        <Layout>
            <NewFormWizard />
            <NewFormWizardChild />

            <form onSubmit={handelTemplate}>
                <section className="mt-4">
                    <div className="row justify-content-center">
                        <div className="text-center col-12 col-md-10">
                            <div className="card">
                                <div className="card-body">
                                    <div className="">
                                        <p className="mb-0 display-4 text-primary event-form-title">Boomerang Template Chooser</p>
                                        <p className="mb-0 text-secondary">Select an existing template from your library, or create a new one.</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="col-md-10">
                            <div className="p-4 bg-white border d-flex flex-column radius-10 ">
                                <div className="d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center">
                                        <ImEqualizer2 size={30} />
                                        <p className="mb-0 ml-2 font-size-16">Template Library</p>
                                    </div>
                                    <div className="float-right">
                                        <button type="button" className="mr-3 btn btn-outline-primary" data-toggle="modal" data-target="#event-frame-modal">Select</button>
                                        <EventBoomerangFrameModal setData={setEventFrameByProps} selectedFrame={selectedFrame} />
                                    </div>
                                </div>
                                <div className="prop__area">
                                    <div className="flex-wrap props-list d-flex">
                                        {
                                            selectedFrame.length > 0 ?
                                                selectedFrame.map((propItem, index) => (
                                                    <div className="prop__item" key={`digital-props-index-${index}`}>
                                                        <img src={`${URL_S3}image/boomerang_frames/preview_image/${propItem.image}`} className="img-fluid" alt="props-data" />
                                                        <span className="remove-props" onClick={removeProps.bind(this, index)}>
                                                            <IoTrashSharp />
                                                        </span>
                                                    </div>
                                                ))

                                                :
                                                <div className="prop__no__item">
                                                    <h4>No Template Selected.</h4>
                                                </div>
                                        }

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="my-5 row justify-content-center">
                        <div className="col-md-10">
                            <button type="button" onClick={BackToPreviousPage} className="float-left px-5 btn btn-outline-secondary radius-10">Back</button>
                            {loading ?
                                (<button className="float-right px-5 btn btn-primary radius-10" disabled>
                                    <LoadingSpinner color="text-white" className="spinner-grow-sm" />
                                </button>)
                                : <button type="submit" disabled={draftLoading} className="float-right px-5 btn btn-primary radius-10">Next</button>
                            }

                            {
                                loading ?
                                    (<button className="float-right px-3 mr-2 btn btn-secondary radius-10" disabled>
                                        <LoadingSpinner color="text-white" className="spinner-grow-sm" />
                                    </button>)
                                    :
                                    <button type="button" onClick={saveAsDraft} className="float-right px-3 mr-2 btn btn-secondary radius-10">Save as draft</button>
                            }
                        </div>
                    </div>
                </section>
            </form>
        </Layout>
    )
}

export default EventBoomerangFrame
